const allgetallcomissionpayment = { data: [], loading: true };

const allcomissionpaymentTableData = { data: [], loading: true, cache: {} };

export const GetCommissionPaymentRed = (state = allgetallcomissionpayment, action) => {
  switch (action.type) {
    case "get_allcomissionpayment":
      return {
        data: action.payload,
        loading: action.loading,
      };
    default:
      return state;
  }
};
export const GetAllCommissionPaymentTableRed = (state = allcomissionpaymentTableData, action) => {
  switch (action.type) {
    case "get_allcomissionpaymenttabledata":
      return {
        ...state,
        data: action.payload,
        loading: action.loader ?? false,
        cache: action.cacheKey
          ? { ...state.cache, [action.cacheKey]: action.payload }
          : state.cache,
      };

    case "clear_compay_cache":
      return {
        ...state,
        cache: {},
      };

    default:
      return state;
  }
};
